import React, {FC} from 'react'
import {ID} from '@/_metronic/helpers'
import * as Yup from 'yup'
import {Formik, Field, Form} from 'formik'
import {TextArea, FormActions, handleErrors} from '@/components/form'
import {setStatus} from '../../../core/_requests'

const schema = Yup.object({
  reason: Yup.string().required()
})

type Props = {
  customerId: ID
  refreshCustomer: () => Promise<void>
  status: string
}

const LockForm: FC<Props> = ({customerId, refreshCustomer, status}) => {

  return (
    <Formik
      initialValues={{reason: ''}}
      validationSchema={schema}
      onSubmit={async (values, {setErrors}) => {
        try {
          await setStatus(customerId, status, values.reason)
          await refreshCustomer()
        } catch (e: unknown) {
          handleErrors(e, setErrors)
        }
      }}
    >
      {({resetForm }) => (
        <Form id="brand" className='form'>
          <Field
            name="reason"
            type="textarea"
            component={TextArea}
            label="Reason"
            required={true}
          />

          <Field
            padding="pt-3"
            component={FormActions}
            position="end"
            close={resetForm}
          />
        </Form>
      )}

    </Formik>
  )
}

export default LockForm
